 <template>
    <div class="search-tool">
        <el-drawer :title="$t('publicPart.search.searchTitle')" append-to-body :visible.sync="drawerVisible"
            size="320px" class="drawerCont" ref="drawer" :wrapperClosable="false"
            v-if="JSON.stringify(advanceSearchFields) !== '{}'">
            <el-scrollbar class="scrollbar">
                <el-form :model="searchForm_transfer" class="drawerForm" label-width="120" label-position="top"  @keydown.enter.native.prevent>
                    <el-form-item v-for="(item, index) in Object.entries(
                        advanceSearchFields
                    )" :key="index" :label="item[1].label" size="small">
                        <el-select v-if="item[1].type === 'select'" v-model="searchForm_transfer[item[0]]" filterable
                            clearable size="small" :placeholder="item[1].label" :multiple="item[1].props && !!item[1].props.multiple">
                            <el-option v-for="(subitem, subindex) in item[1]
                            .options" :key="subindex" :label="subitem.label" :value="subitem.value">
                            </el-option>
                        </el-select>
                        <el-select v-else-if="item[1].type === 'filterSelect'" v-model="searchForm_transfer[item[0]]"
                            :placeholder="item[1].label" filterable clearable :filter-method="filterMethod"
                            :remote="true">
                            <el-option v-for="(subitem, subindex) in item[1]
                            .options" :key="subindex" :label="subitem.label" :value="subitem.value">
                            </el-option>
                        </el-select>
                        <el-date-picker v-else-if="item[1].type === 'cascader'" v-model="searchForm_transfer[item[0]]"
                            type="daterange" range-separator="-" start-placeholder="Start Time"
                            end-placeholder="End Time" size="small" value-format="yyyy-MM-dd" format="yyyy-MM-dd">
                        </el-date-picker>
                        <div class="range" v-else-if="item[1].type === 'range'">
                            <el-input v-model="
                                searchForm_transfer[item[0]][0]
                            " @keyup.enter.native="advanceSearch" maxlength="20" placeholder="Min" size="small"
                                clearable style="width: 120px" v-Int></el-input>-
                            <el-input v-model="
                                searchForm_transfer[item[0]][1]
                            " @keyup.enter.native="advanceSearch" maxlength="20" placeholder="Max" size="small"
                                style="width: 120px" clearable v-Int></el-input>
                        </div>
                        <div v-else-if="item[1].type === 'checkbox'">
                            <el-checkbox v-for="(subitem, subindex) in item[1]
                            .options" :key="subindex" v-model="searchForm_transfer[item[0]]" :label="subitem.value"
                                :true-label="subitem.value">{{ subitem.label }}
                            </el-checkbox>
                        </div>
                        <el-radio-group v-model="searchForm_transfer[item[0]]" v-else-if="item[1].type === 'radio'">
                            <el-radio v-for="(subitem, subindex) in item[1]
                            .options" :key="subindex" :label="subitem.value">{{ subitem.label }}</el-radio>
                        </el-radio-group>
                        <div class="tags" v-else-if="item[1].type === 'tags'">
                            <el-scrollbar style="height: 375px">
                                <el-tag v-for="subitem in item[1].options" :key="subitem.value"
                                    @click="clickTag(item[0], subitem)">
                                    {{ subitem.label }}:
                                    <span class="num">
                                        {{
                                                subitem.count
                                        }}
                                    </span>
                                </el-tag>
                            </el-scrollbar>
                        </div>
                        <el-date-picker v-else-if="item[1].type === 'timer'" v-model="searchForm_transfer[item[0]]"
                            type="date" placeholder="Time" size="small" value-format="yyyy-MM-dd" format="yyyy-MM-dd">
                        </el-date-picker>
                        <el-cascader v-else-if="item[1].type === 'dataCascader'" filterable clearable 
                            :options="item[1].options" :props="item[1].cascaderProps" v-model="searchForm_transfer[item[0]]" placeholder="Plaese Select" size="mini" :show-all-levels="false" style="display: block">
                        </el-cascader>
                        <el-input v-else v-model="searchForm_transfer[item[0]]" clearable size="small"
                            :placeholder="item[1].label" />
                    </el-form-item>
                </el-form>
            </el-scrollbar>
            <div class="searchForm_btns">
                <el-button type="danger" icon="el-icon-refresh-right" size="small" @click="clean">
                    {{
                            $t("publicPart.search.reset")
                    }}
                </el-button>
                <el-button type="primary" class="searchButton" icon="el-icon-search" size="small"
                    @click="advanceSearch">{{ $t("publicPart.search.search") }}</el-button>
            </div>
        </el-drawer>
        <div class="searchCont">
            <div class="searchContLeft">
                <el-form :inline="true" :model="searchForm" label-width="120" @submit.native.prevent @keydown.enter.native.prevent>
                    <el-form-item size="large" class="search_compound">
                        <el-row :class="focusClass">
                            <el-input class="keywords" v-model="searchForm.keyword" :placeholder="inputPlaceholder" maxlength="100" size="large" style="width: 100%"
                                prefix-icon="el-icon-search" @focus="setFocus(true)" @blur="setFocus(false)"
                                @input="search" clearable></el-input>
                        </el-row>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="selected" class="selected">{{ selected }}</div>
            <el-button-group class="search_btnGroup">
                <el-dropdown v-if="menuAuth instanceof Array && menuAuth.length > 1" size="medium" type="primary"
                    trigger="click">
                    <el-button size="large" type="primary" plain>
                        <i class="el-icon-more" />
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="ma in menuAuth" :key="ma.id" :icon="ma.icon"
                            @click.native="authFunc(ma)">{{ ma.name }}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-button v-else-if="menuAuth instanceof Array && menuAuth.length === 1" :class="menuAuth[0].icon" size="large" type="primary" plain @click.native="authFunc(menuAuth[0])"> {{menuAuth[0].name}}</el-button>
                <el-button v-if="showRefresh" class="el-icon-refresh" size="large" type="primary" plain @click="search">Refresh</el-button>
                <el-button class="icon-loudou iconfont_action" size="large" type="primary" plain
                    v-if="JSON.stringify(advanceSearchFields) !== '{}'" @click="drawerVisible = true">Advance
                </el-button>
            </el-button-group>
        </div>
        <div class="search-loading" v-if="loading">
            <el-alert :closable="false" type="success">
                <i class="el-icon-loading" />
                Loading {{ listName }}...
            </el-alert>
        </div>
        <search_infoTags :searchForm="searchForm" :searchList="searchList" :funcName="funcName"></search_infoTags>
    </div>
</template>
<script>
import search_infoTags from "@/common/components/search/search_infoTags";
import { mapState, mapMutations } from "vuex";
export default {
    data() {
        return {
            isFocus: false,
            focusClass: "",
            privateSearchForm: {},
            delay: 500,
            timeout: Number
        };
    },
    props: {
        status: {
            type: Number,
            default: 0
        },
        statusList: {
            type: Array,
            default: []
        },
        funcName: {
            type: String
        },
        searchForm: {
            type: Object,
            default: {
                keyword: ""
            }
        },
        searchList: {
            type: Array,
            default: []
        },
        searchForm_transfer: {
            type: Object,
            default: {
                // status: 0,
            }
        },
        /**
         * {
         *  key: {
         *      label: '',
         *      type: 'select'
         *  }
         * }
         */
        advanceSearchFields: {
            type: Object,
            default: {}
        },
        drawerVisible: {
            type: Boolean,
            default: false
        },
        listName: {
            type: String,
            default: ""
        },
        menuAuth: {
            type: Array,
            default: []
        },
        loading: {
            type: Boolean,
            default: false
        },
        showRefresh: {
            type: Boolean,
            default: true
        },
        inputPlaceholder: {
            type: String,
            default: "Please input Keyword"
        },
        selected: {
            type: Number,
            default: 0
        }
    },
    components: {
        search_infoTags
    },
    computed: {
        // width() {
        //     return `calc(100% - 240px${(this.menuAuth instanceof Array &&
        //         this.menuAuth.length > 0 &&
        //         " - 100px") ||
        //         ""})`;
        // },
        ...mapState({
            routeObj: (state) => state.index.routeObj,
        })
    },
    methods: {
        ...mapMutations(['REPLACEQUERY']),
        setFocus(isTrue) {
            this.focusClass = isTrue ? "is-focus" : "";
        },
        clean() {
            for (let key in this.searchForm) {
                let val = this.searchForm[key];
                switch (typeof val) {
                    case "string":
                        this.searchForm[key] = (key === "status" && "0") || "";
                        break;
                    case "number":
                        this.searchForm[key] = 0;
                        break;
                    case "object":
                        !["tags"].includes(key) &&
                            (this.searchForm[key] =
                                val instanceof Array ? [] : {});
                        break;
                    default:
                        this.searchForm[key] = undefined;
                }
            }
            for (let key in this.searchForm_transfer) {
                let val = this.searchForm_transfer[key];
                switch (typeof val) {
                    case "string":
                        this.searchForm_transfer[key] =
                            (key === "status" && "0") || "";
                        break;
                    case "number":
                        this.searchForm_transfer[key] = 0;
                        break;
                    case "object":
                        !["tags"].includes(key) &&
                            (this.searchForm_transfer[key] =
                                val instanceof Array ? [] : {});
                        break;
                    default:
                        this.searchForm_transfer[key] = undefined;
                }
            }
        },
        search() {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                (this.$parent[this.funcName] || this.$parent.$parent[this.funcName])(1);
                this.$ga.event("engagement", "search", "search_term");
                let route = JSON.parse(JSON.stringify(this.$route.query))
                let { category_id, tags } = route;
                // url携带参数
                this.REPLACEQUERY({
                    category_id,
                    keyword: this.searchForm.keyword,
                    tags,
                });
            }, this.delay);
        },
        advanceSearch() {
            this.searchForm = Object.assign(
                this.searchForm,
                this.searchForm_transfer
            );
            this.$parent.status = this.searchForm.status;
            this.drawerVisible = false;
            (this.$parent[this.funcName] || this.$parent.$parent[this.funcName])(1);
        },
        uthFunc(item) {
            if (item.status_flag == 1) {
                this.$parent[item.funcName]();
            } else {
                this.$parent.batchChangeStatus(item);
            }
        },
        authFunc(item) {
            if (item.status_flag == 1) {
                this.$parent[item.funcName]();
            } else {
                this.$parent.batchChangeStatus(item);
            }
        },
        // 点击tag筛选专用
        clickTag(key, item) {
            this.searchForm_transfer[key] = item.label;
            if (key.indexOf("_name") != -1) {
                this.searchForm_transfer[key.replace("_name", "_id")] =
                    item.value;
            }
            this.advanceSearch();
        },
        filterMethod(val) {
            this.$emit("filterMethod", val);
        }
    },
    created() { },
};
</script>

<style lang="scss">
.range {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.searchCont {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0 15px 10px 15px;
    height: 57px;
    box-sizing: border-box;

    .selected {
        color: #635cff;
        display: flex;
        margin-right: 24px;
        align-items: center;

        &:before {
            content: 'Selected:';
            display: inline-block;
            margin-right: 8px;
            color: #606266;
        }
    }

    .searchContLeft {
        flex: 1;
        display: flex;
        align-items: center;

        .el-form {
            width: 100%;

            .el-form-item {
                width: 100%;

                .el-form-item__content {
                    width: 96%;

                    .el-row {
                        border: 2px solid #fff;
                        border-radius: 6px;

                        .keywords {
                            width: 100%;

                            input {
                                width: 100%;
                                border-radius: 4px;

                                &:focus {
                                    border-color: #c0c6cc;
                                }
                            }

                            .el-input__suffix {
                                .el-input__suffix-inner {
                                    .el-input__icon.el-icon-circle-close.el-input__clear {
                                        font-size: 17px;
                                        color: #9c9da0;
                                        font-weight: bold;
                                    }
                                }
                            }
                        }

                        &.is-focus {
                            border-color: $color-border-blue;
                        }
                    }
                }

                &.search_compound {
                    margin-bottom: 0;
                }
            }
        }
    }

    .el-button-group {
        padding-top: 4px;

        .el-dropdown {
            float: left;
            right: -2px;
        }

        .el-button {
            font-size: 13px;
            border-radius: 4px;
            color: $color-text-primary;
            font-weight: normal;
            background-color: #fff;
            border-color: #babfc3;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;

            &:last-child {
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
                border-top-right-radius: 3px;
                border-bottom-right-radius: 3px;
            }

            &:first-child {
                border-top-left-radius: 3px;
                border-bottom-left-radius: 3px;
            }

            &:not(:first-child):not(:last-child) {
                border-left-color: #babfc3;
                border-right-color: #babfc3;
            }
        }
    }

    /* 
    &::after {
        content: " ";
        width: 0;
        height: 0;
        float: none;
        clear: both;
    } */
}

.search-loading {
    padding: 0 15px 12px;
    width: auto;
    position: absolute;
    width: calc(100% - 30px);
    z-index: 9;
    background: #fff;
    box-shadow: 0 2px 4px 0 #eee;
    margin-top: -1px;

    .el-alert {
        background-color: #ebf9fc;

        .el-alert__content {
            padding: 3px 0;

            .el-alert__description {
                margin-top: 0;
                color: #367783;

                i {
                    font-size: 120%;
                }
            }
        }
    }
}

.el-dropdown-menu.el-popper.el-dropdown-menu--medium {
    li {
        margin-left: 5px;
        margin-right: 5px;
    }
}

.drawerCont {
    .el-drawer__header {
        font-size: 18px !important;
        text-align: left;
        line-height: 2;
        border-bottom: 1px solid #ddd;
        padding: 0;
        margin: 12px 12px 0 12px;
        text-indent: 12px;
    }

    .el-drawer__body {
        height: 100%;

        .el-form-item {
            .el-form-item__label {
                font-size: 12px;
                line-height: 20px !important;
                height: 20px !important;
            }
        }

        .el-select,
        .el-date-editor {
            width: 100% !important;
        }

        .scrollbar {
            height: calc(100% - 100px);
            overflow-x: hidden;

            .el-scrollbar__wrap {
                overflow-x: hidden;

                .el-scrollbar__view {
                    height: 100%;
                }
            }
        }
    }

    .drawerForm {
        position: relative;
        height: 100%;
        box-sizing: border-box;
        padding: 12px 24px;

        .el-radio-group,
        .el-checkbox {
            width: 100%;

            .el-checkbox__label {
                font-size: 12px;
            }
        }

        .tags {
            .el-tag {
                user-select: none;
                cursor: pointer;

                &:hover {
                    opacity: 0.6;
                }

                &:active {
                    opacity: 0.3;
                }

                .num {
                    color: $color-danger;
                }
            }
        }

    }
    
        .searchForm_btns {
            position: absolute;
            width: 100%;
            left: 0;
            bottom: 0;
            padding: 12px 24px;
            box-sizing: border-box;
            background-color: $color-white;
            text-align: right;

            .el-button + .el-button{
                margin:10px 0 0 0;
            }
        }

    .drawer-footer {
        width: 100%;
        display: flex;
        /* justify-content: space-around; */
        padding: 10px 20px;
        position: absolute;
        bottom: 0;
        background: #fff;
    }

    .searchButton {
        width: 100%;
    }
}
</style>